__turbopack_context__.v({
  "header": "DialogHeader-module__9iwrnq__header",
  "headerRow": "DialogHeader-module__9iwrnq__headerRow",
  "titleGroup": "DialogHeader-module__9iwrnq__titleGroup",
});
